import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureEntityUpsert } from "../types";

export const useUpdateFixtureEntity = (options: UseMutationOptions<unknown, unknown, FixtureEntityUpsert> = {}) => {
  const request = useApi();
  const { sport, organizationId, fixtureId } = useParams();

  if (!sport || !organizationId || !fixtureId) {
    console.error({ sport, organizationId, fixtureId });
    throw new Error("Missing required params");
  }

  return useMutation<unknown, unknown, FixtureEntityUpsert, unknown>({
    mutationFn: (body: FixtureEntityUpsert) =>
      request(`${sport}/o/${organizationId}/fixtures/${fixtureId}/entities`, {
        body,
        method: "POST",
      }),
    ...options,
  });
};
